var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "sidebarFilter" }, [
    _c("div", { staticClass: "sidebarFilter__wrapperRadioButton" }, [
      _c("label", { staticClass: "sidebarFilter__container" }, [
        _c("input", {
          staticClass: "sidebarFilter__input",
          attrs: {
            id: "relevance",
            "data-gtm": "sidebarFilter__sort--relevance",
            type: "radio",
          },
          domProps: {
            checked: _vm.checkSortRelevance,
            value: _vm.sortOptions[0].value,
          },
          on: {
            click: function ($event) {
              return _vm.selectSort(_vm.sortOptions[0].name)
            },
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "sidebarFilter__radioButton" }),
        _vm._v(
          "\n            " + _vm._s(_vm.sortOptions[0].name) + "\n        "
        ),
      ]),
      _vm._v(" "),
      _c("label", { staticClass: "sidebarFilter__container" }, [
        _c("input", {
          staticClass: "sidebarFilter__input",
          attrs: {
            id: "publicationDate",
            "data-gtm": "sidebarFilter__sort--publicationDate",
            type: "radio",
          },
          domProps: {
            checked: _vm.checkSortPublicationDate,
            value: _vm.sortOptions[1].value,
          },
          on: {
            click: function ($event) {
              return _vm.selectSort(_vm.sortOptions[1].name)
            },
          },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "sidebarFilter__radioButton" }),
        _vm._v(
          "\n            " + _vm._s(_vm.sortOptions[1].name) + "\n        "
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }